"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocsIcon64Regular_1 = require("./icons/DocsIcon/DocsIcon64Regular");
Object.defineProperty(exports, "DocsIcon64Regular", { enumerable: true, get: function () { return DocsIcon64Regular_1.DocsIcon64Regular; } });
